import type { Tenant } from "./TenantProvider";

/**
 * Extract a display name from a tenant's scopes
 */
export function getTenantDisplayName(tenant: Tenant): string {
  const names = new Set<string>();
  for (const scope of tenant.scopes) {
    if (scope.kind === "customer" || scope.kind === "branch") {
      if (scope.name) names.add(scope.name);
    } else if (scope.kind === "test") {
      names.add(scope.unique);
    }
  }

  if (names.size === 0) {
    return tenant.id;
  }

  return Array.from(names).join(", ");
}

/**
 * Filter tenants by display name or ID against a search query.
 * Returns all tenants when the query is empty or whitespace-only.
 * Results are sorted alphabetically by display name using locale-aware comparison.
 */
export function filterTenants(tenants: readonly Tenant[], searchQuery: string): readonly Tenant[] {
  const collator = new Intl.Collator("en-AU", { sensitivity: "base" });
  const sorted = [...tenants].sort((a, b) => collator.compare(getTenantDisplayName(a), getTenantDisplayName(b)));
  if (!searchQuery.trim()) return sorted;
  const query = searchQuery.toLowerCase();
  return sorted.filter(
    (tenant) => getTenantDisplayName(tenant).toLowerCase().includes(query) || tenant.id.toLowerCase().includes(query),
  );
}
